import React, { useMemo, useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Typography } from "@material-ui/core";
import {
  ProductOwnedGridView,
  ProductOwnedListView,
  SortIcon,
} from "../../../LeftNav/SvgIcons";
import { useDispatch, useSelector } from "react-redux";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@material-ui/core";
import { ItemImage, Pagination } from "../../../../../components/common";
import ProductOwnedFilter from "../ProductOwnedFilter";
import { endUserActions } from "../../../../../store/endUser/endUserActions";
import { contactsActions } from "../../../../../store/contacts/contactsActions";
import { useLocation } from "react-router-dom";

const endUserList = [
  {
    firstName: "Zaeem",
    lastName: "Ehsanullah",
    deviceRegistered: "1",
    groupName: "Test",
    groupColor: "",
    lastLoginDT: "1 mont ago",
    productMainImage: "",
  },
];

const useStyles = makeStyles(theme => ({
  inenerContent: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },

  content: {
    fontSize: 14,
    fontWeight: 400,
    fontFamily: "Roboto",
    color: "#434D56",
    padding: "16px 0px",
  },
  productContent: {
    padding: "32px 0px",
  },
  contentHeading: {
    color: "#181C32",
    fontFamily: "Roboto",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "700",
    paddingBottom: "32px",
  },

  gridHeaderInner: {
    color: "#A9B2BC",
    fontSize: "12px",
    fontWeight: "700",
    paddingTop: "12px",
    paddingBottom: "9px",
  },
  gridHeader: {
    background: "#E5F2FF",
    borderRadius: "6px",
    "& .MuiTableCell-root": {
      borderBottom: "none",
    },
  },
  gridHeaderRow: {
    borderRadius: "6px",
  },
  gridBodyInner: {
    color: "#464E5F",
    fontSize: "14px",
    fontWeight: "400",
    paddingTop: "4px",
    paddingBottom: "4px",
  },
  topPagination: {
    color: "#70808F",
    fontSize: "12px",
    fontWeight: "500",
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "10px",
  },
  selectButtonCell: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    paddingTop: "10px",
  },
  popupSelectedButton: {
    backgroundColor: "#18bc6d",
  },
  popupSelectButton: {
    backgroundColor: "#3699FF",
  },
  sortIcon: {
    marginLeft: "10px",
    cursor: "pointer",
  },
}));

const BussinesContactChooseLoction = ({ companyId }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const { companyLocation } = useSelector(state => state.ContactsReducer);
  const [listData, setListData] = useState([]);
  const [selectedLoc, setSelectedLoc] = useState();
  const [companyUsers, setCompanyUsers] = useState([]);
  const [listUserData, setListUserData] = useState([]);
  const [selectedUsr, setSelectedUsr] = useState();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [paginationResponse, setPaginationResponse] = useState({
    currentCount: 0,
    totalRecords: 0,
  });
  const [sortKey, setSortKey] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");
  const [usrSortKey, setUsrSortKey] = useState(null);
  const [usrSortDirection, setUsrSortDirection] = useState("asc");

  useEffect(() => {
    if (companyId) {
      dispatch(contactsActions.onGetCompanyUsers(parseInt(companyId))).then(
        data => {
          if (data?.success) {
            setCompanyUsers(data?.data);
            setListUserData(data?.data);
          }
        }
      );
    }
    dispatch(endUserActions.onGetEnvIcons());
  }, []);

  const searching = value => {
    if (value === "") {
      setListData(companyLocation);
    } else {
      let filterRec = companyLocation?.filter(
        x =>
          x?.nickName?.toLowerCase().includes(value?.toLowerCase()) ||
          x?.address?.toLowerCase().includes(value?.toLowerCase())
      );
      setListData(filterRec);
    }
  };
  const searchingUser = value => {
    if (value === "") {
      setListUserData(companyUsers);
    } else {
      let filterRec = companyUsers?.filter(
        x =>
          x?.contactName?.toLowerCase().includes(value?.toLowerCase()) ||
          x?.emailAddress?.toLowerCase().includes(value?.toLowerCase())
      );
      setListUserData(filterRec);
    }
  };

  const onUsrSort = (key, direction) => {
    setUsrSortKey(key);
    setUsrSortDirection(direction);
  };
  const onSort = (key, direction) => {
    setSortKey(key);
    setSortDirection(direction);
  };

  const onSelectProduct = item => {
    setSelectedLoc(item);
    dispatch(endUserActions.onChangeOfRegister("companyLocation", item));
    dispatch(
      endUserActions.onChangeOfRegister("purchaseLocation", item?.address)
    );
    dispatch(endUserActions.onChangeOfRegister("purchaseLocId", item.id));
    dispatch(endUserActions.onChangeOfRegister("comLocId", item.companyId));
  };

  const onSelectUser = item => {
    setSelectedUsr(item);
    dispatch(endUserActions.onChangeOfRegister("companyUser", item));
    dispatch(endUserActions.onGetEnvWithDeviceCount(item.id));
  };

  const sortedData = useMemo(() => {
    if (!sortKey) return listData;

    const sorted = [...listData].sort((a, b) => {
      if (a[sortKey] < b[sortKey]) return sortDirection === "asc" ? -1 : 1;
      if (a[sortKey] > b[sortKey]) return sortDirection === "asc" ? 1 : -1;
      return 0;
    });

    return sorted;
  }, [listData, sortKey, sortDirection]);

  const sortedUsrData = useMemo(() => {
    if (!usrSortKey) return listUserData;

    const sorted = [...listUserData].sort((a, b) => {
      if (a[usrSortKey] < b[usrSortKey])
        return usrSortDirection === "asc" ? -1 : 1;
      if (a[usrSortKey] > b[usrSortKey])
        return usrSortDirection === "asc" ? 1 : -1;
      return 0;
    });

    return sorted;
  }, [listUserData, usrSortKey, usrSortDirection]);

  return (
    <div>
      <div className={classes.productContent}>
        <Typography className={classes.contentHeading}>
          Choose Location
        </Typography>
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
          }}>
          <ProductOwnedFilter
            setSearchDevice={s => {
              searching(s);
            }}
          />
          {/* <ProductOwnedGridView />
          <ProductOwnedListView /> */}
        </div>
      </div>
      {/* <div className={classes.topPagination} >
        <span>
          {page}-{rowsPerPage} of&nbsp;
          {paginationResponse?.totalRecords}
        </span>
      </div> */}

      <Paper>
        <Table>
          <TableHead className={classes.gridHeader}>
            <TableRow className={classes.gridHeaderRow}>
              <TableCell className={classes.gridHeaderInner}>
                Location Nickname
                <TableSortLabel
                  className={classes.sortIcon}
                  active={sortKey === "nickName"}
                  direction={sortDirection}
                  onClick={() =>
                    onSort("nickName", sortDirection === "asc" ? "desc" : "asc")
                  }
                  IconComponent={SortIcon}
                />
              </TableCell>
              <TableCell className={classes.gridHeaderInner}>
                Show in Locator
                <TableSortLabel
                  className={classes.sortIcon}
                  active={sortKey === "showInLocator"}
                  direction={sortDirection}
                  onClick={() =>
                    onSort(
                      "showInLocator",
                      sortDirection === "asc" ? "desc" : "asc"
                    )
                  }
                  IconComponent={SortIcon}
                />
              </TableCell>
              <TableCell className={classes.gridHeaderInner}>
                Address
                <TableSortLabel
                  className={classes.sortIcon}
                  active={sortKey === "address"}
                  direction={sortDirection}
                  onClick={() =>
                    onSort("address", sortDirection === "asc" ? "desc" : "asc")
                  }
                  IconComponent={SortIcon}
                />
              </TableCell>
              <TableCell className={classes.gridHeaderInner}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData.map((item, index) => {
              return (
                <TableRow key={index} className='gridBodyRow'>
                  <TableCell className={classes.gridBodyInner}>
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}>
                      <ItemImage imgSrc={""} />
                      <span>{item.nickName}</span>
                    </span>
                  </TableCell>
                  <TableCell className={classes.gridBodyInner}>
                    {item.showInLocator == true ? "Yes" : "No"}
                  </TableCell>
                  <TableCell className={classes.gridBodyInner}>
                    {item.address}
                  </TableCell>

                  {/* <TableCell className={classes.gridBodyInner}>
                            {item.lastLoginDT !== null &&
                            item.lastLoginDT !== ""
                              ? moment(item.lastLoginDT).fromNow()
                              : ""}
                          </TableCell> */}
                  <TableCell
                    className={`${classes.gridBodyInner} ${classes.selectButtonCell}`}>
                    <span
                    // onClick={() => redirectUrl(item)}
                    >
                      {/* <EditIcon /> */}
                      <Button
                        color='primary'
                        variant='contained'
                        className={
                          selectedLoc === item
                            ? classes.popupSelectedButton
                            : classes.popupSelectButton
                        }
                        onClick={() => onSelectProduct(item)}>
                        {selectedLoc === item ? "selected" : "Select"}
                      </Button>
                    </span>
                  </TableCell>
                </TableRow>
              );
            })}
            {sortedData.length <= 0 && (
              <TableRow key='0' className='gridBodyRow'>
                <TableCell
                  colSpan='7'
                  className={classes.gridBodyInner}
                  style={{ textAlign: "center" }}>
                  <span className='emptyGridText'>
                    Uh Oh! You haven’t created any location.
                  </span>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>

      <div className={classes.productContent}>
        <Typography className={classes.contentHeading}>Choose User</Typography>
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
          }}>
          <ProductOwnedFilter
            setSearchDevice={s => {
              searchingUser(s);
            }}
          />
          {/* <ProductOwnedGridView />
          <ProductOwnedListView /> */}
        </div>
      </div>
      <Paper>
        <Table>
          <TableHead className={classes.gridHeader}>
            <TableRow className={classes.gridHeaderRow}>
              <TableCell className={classes.gridHeaderInner}>
                User Name
                <TableSortLabel
                  className={classes.sortIcon}
                  active={usrSortKey === "contactName"}
                  direction={usrSortDirection}
                  onClick={() =>
                    onUsrSort(
                      "contactName",
                      usrSortDirection === "asc" ? "desc" : "asc"
                    )
                  }
                  IconComponent={SortIcon}
                />
              </TableCell>

              <TableCell className={classes.gridHeaderInner}>
                Email Address
                <TableSortLabel
                  className={classes.sortIcon}
                  active={usrSortKey === "emailAddress"}
                  direction={usrSortDirection}
                  onClick={() =>
                    onUsrSort(
                      "emailAddress",
                      usrSortDirection === "asc" ? "desc" : "asc"
                    )
                  }
                  IconComponent={SortIcon}
                />
              </TableCell>
              <TableCell className={classes.gridHeaderInner}>
                Role
                <TableSortLabel
                  className={classes.sortIcon}
                  active={usrSortKey === "role"}
                  direction={usrSortDirection}
                  onClick={() =>
                    onUsrSort(
                      "role",
                      usrSortDirection === "asc" ? "desc" : "asc"
                    )
                  }
                  IconComponent={SortIcon}
                />
              </TableCell>
              <TableCell className={classes.gridHeaderInner}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedUsrData.map((item, index) => {
              return (
                <TableRow key={index} className='gridBodyRow'>
                  <TableCell className={classes.gridBodyInner}>
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}>
                      <ItemImage imgSrc={""} />
                      <span>{item?.contactName}</span>
                    </span>
                  </TableCell>
                  <TableCell className={classes.gridBodyInner}>
                    {item?.emailAddress}
                  </TableCell>
                  <TableCell className={classes.gridBodyInner}>
                    {item?.role}
                  </TableCell>
                  <TableCell
                    className={`${classes.gridBodyInner} ${classes.selectButtonCell}`}>
                    <span
                    // onClick={() => redirectUrl(item)}
                    >
                      {/* <EditIcon /> */}
                      <Button
                        color='primary'
                        variant='contained'
                        className={
                          selectedUsr === item
                            ? classes.popupSelectedButton
                            : classes.popupSelectButton
                        }
                        onClick={() => onSelectUser(item)}>
                        {selectedUsr === item ? "selected" : "Select"}
                      </Button>
                    </span>
                  </TableCell>
                </TableRow>
              );
            })}
            {sortedUsrData.length <= 0 && (
              <TableRow key='0' className='gridBodyRow'>
                <TableCell
                  colSpan='7'
                  className={classes.gridBodyInner}
                  style={{ textAlign: "center" }}>
                  <span className='emptyGridText'>
                    Uh Oh! You haven’t created any User.
                  </span>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>

      {/* <Pagination
        recordCount={paginationResponse?.totalRecords}
        page={page - 1}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      /> */}
    </div>
  );
};

export default BussinesContactChooseLoction;
